import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "userDisplayName" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "userBlock",
    style: {"display":"inline-flex","justify-content":"flex-start","align-items":"center"},
    to: '/' + _ctx.dtoUser.userName
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        class: "avatar_image",
        style: {"border-radius":"50%"},
        src: _ctx.urls.getUserImageSrc(_ctx.dtoUser),
        alt: _ctx.dtoUser.displayName
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.dtoUser.displayName), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}